import PropTypes from "prop-types";
import davIcon from "assets/icons/dav.svg";
import { getLoaderTheme } from "core/loader/loaderTheme";
import "components/modal/Modal.scss";
import "core/loader/BrandedFullPageLoader.scss";

const BrandedFullPageLoader = ({ text = "Chargement…", overlay = false, theme }) => {
  const resolvedTheme = theme || getLoaderTheme();
  return (
    <div
      className={`branded-fullpage-loader branded-fullpage-loader--${resolvedTheme}${
        overlay ? " branded-fullpage-loader--overlay" : ""
      }`}
    >
      <div className="icon-pending branded-fullpage-loader__ring">
        <img src={davIcon} alt="" className="dav-pending-icon" />
      </div>
      {text ? <div className="branded-fullpage-loader__text">{text}</div> : null}
    </div>
  );
};

BrandedFullPageLoader.propTypes = {
  text: PropTypes.string,
  overlay: PropTypes.bool,
  theme: PropTypes.oneOf(["sso", "app"]),
};

export default BrandedFullPageLoader;
